import HelpContent from "./HelpContent.component";

export default HelpContent;
